import React from "react";
import { graphql } from "gatsby";
import * as styles from "./hero.module.css";
import VisuallyHidden from "../../components/VisuallyHidden";
import Logo from "../../components/Logo";

export const Hero = ({ slice: _slice }) => {
  return (
    <section
      className={styles.hero}
      data-highlight-background="spice-red"
      data-highlight-foreground="white"
      data-tilt-scheme="right"
    >
      <div className={styles.background}>
        <div className={styles.scrollWrapper}>
          <div className={styles.scrollImageWrapper}>
            <img
              src="/images/hero-bg-v3.jpg"
              loading="eager"
              alt=""
              width={1920}
              height={961}
            />
          </div>
          <div className={styles.scrollImageWrapper}>
            <img
              src="/images/hero-bg-v3.jpg"
              loading="eager"
              alt=""
              width={1920}
              height={961}
            />
          </div>
        </div>
      </div>
      {/* <div className={styles.image}>
        <motion.img
          src="/images/hero-img.jpg"
          loading="eager"
          alt=""
          width={310}
          height={394}
          initial={{ opacity: 0, scale: 0.8, rotate: -5 }}
          animate={{ opacity: 1, scale: 1, rotate: 0 }}
          transition={{ duration: 0.8, delay: 0.3, ease: [0.25, 0.1, 0.25, 1] }}
        />
      </div> */}
      <div className={"page-width " + styles.content}>
        <h1>
          We are <VisuallyHidden>Doing Things Media</VisuallyHidden>
        </h1>
        <div className={styles.logo}>
          <Logo variant="stacked" color="white" />
        </div>
      </div>
    </section>
  );
};

export const query = graphql`
  fragment HomepageDataBodyHero on PrismicHomepageDataBodyHero {
    primary {
      heading {
        richText
      }
    }
  }
`;
